import { createTheme } from '@one-thd/sui-atomic-components';

const DewaltPrimary = createTheme({
  palette: {
    mode: 'light',
    background: {
      primary: 'brand'
    }
  }
});

DewaltPrimary.palette['--sui-palette-background-primary'] = '255 189 24';

export { DewaltPrimary };
